import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'talk-to-your-data-suggestion-card',
  templateUrl: './suggestion-card.component.html',
  styleUrls: ['./suggestion-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuggestionCardComponent {
  @Input() title = '';
  @Input() description = '';
  @Output() readonly selected = new EventEmitter<void>();
}
